var map = {
	"./common.png": "ae65",
	"./excel.png": "b200",
	"./face_ex.png": "47ef",
	"./mp4.png": "0ebc",
	"./pdf.png": "3614",
	"./pic.png": "3e48",
	"./ppt.png": "788a",
	"./word.png": "6501",
	"./zip.png": "02c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1800";